import React, { useRef, Suspense, useState, useEffect } from "react";
import { useGLTF } from "@react-three/drei";
import * as THREE from "three";
import { useLoader, useFrame } from "@react-three/fiber";
import ListScreen from "./ListScreen";

export function Screens(props) {
  // const [image1] = useRef()

  // const screenRefs = React.useRef([]);
  // screenRefs.current = ListScreen.map((_, i) => screenRefs.current[i] ?? createRef());

  const { nodes } = useGLTF("./models/environment/combined/affiches.glb");

  /* 19D */
  //const texture3 =  useLoader(THREE.TextureLoader, ListScreen[2].image);
  const textureNinteen1 = useLoader(
    THREE.TextureLoader,
    ListScreen.ninteen[0].image
  );
  const textureNinteen2 = useLoader(
    THREE.TextureLoader,
    ListScreen.ninteen[1].image
  );
  const textureNinteen3 = useLoader(
    THREE.TextureLoader,
    ListScreen.ninteen[2].image
  );
  textureNinteen1.flipY = false;
  textureNinteen2.flipY = false;
  //texture3.flipY = false
  textureNinteen3.flipY = false;

  /* ALPHA */
  const textureAlpha1 = useLoader(
    THREE.TextureLoader,
    ListScreen.alpha[0].image
  );
  const textureAlpha3 = useLoader(
    THREE.TextureLoader,
    ListScreen.alpha[1].image
  );
  textureAlpha1.flipY = false;
  textureAlpha3.flipY = false;

  /* TEGRA */
  const textureTegra1 = useLoader(
    THREE.TextureLoader,
    ListScreen.tegra[0].image
  );
  const textureTegra2 = useLoader(
    THREE.TextureLoader,
    ListScreen.tegra[1].image
  );
  const textureTegra4 = useLoader(
    THREE.TextureLoader,
    ListScreen.tegra[2].image
  );
  textureTegra1.flipY = false;
  textureTegra2.flipY = false;
  textureTegra4.flipY = false;

  /* MC LAREN */

  const textureMcL1 = useLoader(
    THREE.TextureLoader,
    ListScreen.mclaren[0].image
  );
  const textureMcL2 = useLoader(
    THREE.TextureLoader,
    ListScreen.mclaren[1].image
  );
  const textureMcL3 = useLoader(
    THREE.TextureLoader,
    ListScreen.mclaren[2].image
  );
  const textureMcL4 = useLoader(
    THREE.TextureLoader,
    ListScreen.mclaren[3].image
  );
  textureMcL1.flipY = false;
  textureMcL2.flipY = false;
  textureMcL3.flipY = false;
  textureMcL4.flipY = false;

  /* SUSTANABLE NO READY */
  const textureRse1 = useLoader(THREE.TextureLoader, ListScreen.rse[0].image);
  const textureRse2 = useLoader(THREE.TextureLoader, ListScreen.rse[1].image);
  textureRse1.flipY = false;
  textureRse2.flipY = false;

  /* Voyageur */
  /*
  const textureVoyageur1 = useLoader(
    THREE.TextureLoader,
    ListScreen.voyageur[0].image
  );
  const textureVoyageur2 = useLoader(
    THREE.TextureLoader,
    ListScreen.voyageur[1].image
  );
  textureVoyageur1.flipY = false;
  textureVoyageur2.flipY = false;
*/
  //  const textureList = [texture, texture2]
  //  let textureFinale = texture
  //  let test = true

  const videoNinteenRef = useRef();
  const videoAlphaRef = useRef();
  const videoRseRef = useRef();
  const videoTegraRef = useRef();

  useFrame((state) => {
    /* const t = state.clock.getElapsedTime()
      textureFinale = textureList[Math.floor(t/10%textureList.length)]
      if(imagetest.current)
      {
        imagetest.current.map = textureFinale
      }*/

    if (videoNinteenRef.current) {
      videoTegraRef.current.flipY = false;
      videoNinteenRef.current.flipY = false;
      videoAlphaRef.current.flipY = false;
      videoRseRef.current.flipY = false;
    }
  });

  const [videoNinteen] = useState(() =>
    Object.assign(document.createElement("video"), {
      src: "./videos/19degree/01.mp4",
      muted: true,
      crossOrigin: "Anonymous",
      loop: true,
    })
  );
  const [videoAlpha] = useState(() =>
    Object.assign(document.createElement("video"), {
      src: "./videos/alpha/01.mp4",
      muted: true,
      crossOrigin: "Anonymous",
      loop: true,
    })
  );
  const [videoRse] = useState(() =>
    Object.assign(document.createElement("video"), {
      src: "./videos/rse/01.mp4",
      muted: true,
      crossOrigin: "Anonymous",
      loop: true,
    })
  );
  const [videoTegra] = useState(() =>
    Object.assign(document.createElement("video"), {
      src: "./videos/tegra/01.mp4",
      muted: true,
      crossOrigin: "Anonymous",
      loop: true,
    })
  );
  /*
  const [videoRSE] = useState(() =>
    Object.assign(document.createElement("video"), {
      src: "./videos/tumi-valise.mp4",
      muted: true,
      crossOrigin: "Anonymous",
      loop: true,
    })
  );
*/
  useEffect(() => {
    if (videoNinteen) {
      const videoTegraRef = videoTegra.play();
      const videoNinteenRef = videoNinteen.play();
      const videoAlphaRef = videoAlpha.play();
      const videoRseRef = videoRse.play();
    }
  }, [videoTegra, videoNinteen, videoAlpha, videoRse]);

  return (
    <group {...props} dispose={null}>
      <group scale={0.7}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.affiches19Degree_01.geometry}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={9.8}
          position={[-0.1, 0, 0]}
        >
          <meshBasicMaterial attach="material" map={textureNinteen1} />
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.affiches19Degree_02.geometry}
          position={[-61.86, 12.71, -56.91]}
          rotation={[0.02, 0.02, -1.57]}
          scale={9.8}
        >
          <meshBasicMaterial attach="material" map={textureNinteen2} />
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.affiches19Degree_03.geometry}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={9.8}
          position={[0.1, 0, 0]}
        >
          <meshBasicMaterial attach="material" map={textureNinteen3} />
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.affiches19Degree_04.geometry}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={9.8}
          position={[0.1, 0, 0]}
        >
          <meshBasicMaterial toneMapped={false}>
            <videoTexture
              attach="map"
              args={[videoNinteen]}
              encoding={THREE.sRGBEncoding}
              ref={videoNinteenRef}
            />
          </meshBasicMaterial>
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.affichesAlphaBravo_01.geometry}
          rotation={[-Math.PI / 2, 0, 0]}
          position={[-29.21, 18.82, -13.74]}
          scale={9.8}
        >
          <meshBasicMaterial attach="material" map={textureAlpha1} />
        </mesh>
        <group position={[-5.11, -3.62, 25.96]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.affichesAlphaBravo_012.geometry}
            position={[-34.89, 9.08, -13.42]}
            rotation={[Math.PI / 2, Math.PI, 0]}
            scale={[7.53, 9.8, 7.53]}
          >
            <meshBasicMaterial attach="material" map={textureAlpha1} />
          </mesh>
        </group>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.affichesAlphaBravo_02video.geometry}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={9.8}
          position={[0.1, 0, 0]}
        >
          <meshBasicMaterial toneMapped={false}>
            <videoTexture
              attach="map"
              args={[videoAlpha]}
              encoding={THREE.sRGBEncoding}
              ref={videoAlphaRef}
            />
          </meshBasicMaterial>
        </mesh>
        <mesh
          name="affichesAlphaBravo_03video"
          castShadow
          receiveShadow
          geometry={nodes.affichesAlphaBravo_03.geometry}
          material={nodes.affichesAlphaBravo_03.material}
          position={[-27.36, 0.25, -14.32]}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={[5.86, 9.8, 5.86]}
        >
          <meshBasicMaterial attach="material" map={textureAlpha3} />
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.affichesMcLaren_01.geometry}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={9.8}
        >
          <meshBasicMaterial attach="material" map={textureMcL1} />
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.affichesMcLaren_02.geometry}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={9.8}
        >
          <meshBasicMaterial attach="material" map={textureMcL2} />
        </mesh>
        <group position={[47.36, 10.1, -38.32]} scale={1.43}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.affichesMcLaren03.geometry}
            position={[-35.9, -13.56, 29.68]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={[7.36, 6.86, 8.9]}
          >
            <meshBasicMaterial attach="material" map={textureMcL3} />
          </mesh>
        </group>
        <group position={[47.36, 10.1, -38.32]} scale={1.49}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.haffichesMcLaren04.geometry}
            position={[-157.33, -20.38, 35.78]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={[25.37, 6.86, 22.77]}
          >
            <meshBasicMaterial attach="material" map={textureMcL4} />
          </mesh>
        </group>

        <mesh
          castShadow
          receiveShadow
          geometry={nodes.affichesSustainable_01.geometry}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={9.8}
        >
          <meshBasicMaterial attach="material" map={textureRse1} />
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.affichesSustainable_02.geometry}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={9.8}
        >
          <meshBasicMaterial attach="material" map={textureRse2} />
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.affichesTegra_01.geometry}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={9.8}
          position={[0.1, 0, 0]}
        >
          <meshBasicMaterial attach="material" map={textureTegra1} />
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.affichesTegra_02.geometry}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={9.79}
        >
          <meshBasicMaterial attach="material" map={textureTegra2} />
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.affichesTegra_video.geometry}
          position={[-42.02, 3.51, 45.5]}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={[7.28, 9.8, 8.86]}
        >
          <meshBasicMaterial toneMapped={false}>
            <videoTexture
              attach="map"
              args={[videoTegra]}
              encoding={THREE.sRGBEncoding}
              ref={videoTegraRef}
            />
          </meshBasicMaterial>
        </mesh>
        <group position={[-0.85, -0.2, -2.19]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.affichesTegra_04.geometry}
            material={nodes.affichesTegra_04.material}
            position={[-30.53, 10.55, 25.93]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={[9.8, 3.69, 3.98]}
          >
            <meshBasicMaterial attach="material" map={textureTegra4} />
          </mesh>
        </group>
      </group>

      <group position={[6.15, -0.66, 23.55]} scale={0.7}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.affichesSustainable_video_rse.geometry}
          material={nodes.affichesSustainable_video_rse.material}
          position={[-33.85, 27.82, 54.97]}
          rotation={[-Math.PI / 2, 0, 1.57]}
          scale={[9.8, 15.02, 13.54]}
        >
          <meshBasicMaterial toneMapped={false}>
            <videoTexture
              attach="map"
              args={[videoRse]}
              encoding={THREE.sRGBEncoding}
              ref={videoRseRef}
            />
          </meshBasicMaterial>
        </mesh>
      </group>
    </group>
  );
}

useGLTF.preload("./models/environment/combined/affiches.glb");
